import { PageIntro } from "../components/portfolio/PageIntro";
import { Seo } from "../components/portfolio/Seo";
import { About } from "../components/portfolio/About";
import { Manifesto } from "../components/portfolio/Manifesto";
import { AIPractice } from "../components/portfolio/AIPractice";
import { Expertise } from "../components/portfolio/Expertise";
import { Timeline } from "../components/portfolio/Timeline";
import { Testimonials } from "../components/portfolio/Testimonials";
import { MiniFooter } from "../components/portfolio/MiniFooter";

export default function InstructionalDesignPage() {
  return (
    <div className="pt-20">
      <Seo
        title="Instructional Design"
        description="13 years of instructional design and ERP training: e-learning, ILT, job aids, and enterprise rollouts across Oracle, PeopleSoft, Infor, Workday and Fusion."
      />
      <PageIntro kicker="Instructional Design">
        Thirteen years turning complex enterprise systems into training people actually understand.
      </PageIntro>
      <About />
      <Manifesto />
      <AIPractice />
      <Testimonials />
      <Expertise />
      <Timeline />
      <MiniFooter />
    </div>
  );
}
